export { CardArticle } from './CardArticle';
export { type CardArticleProps } from './CardArticle';
